<template>
  <div class="field-set">
    <div
      v-if="field.title"
      class="field__title"
    >
      {{field.title}}
    </div>
    <div
      v-if="field.text"
      class="field__description"
    >
      {{field.text}}
    </div>
    <RadioCheckboxGroup
      v-bind:fieldArray="field.fields"
      v-bind:type="field.type"
      v-bind:inline="field.inline"
    />
  </div>
</template>

<script>
// @ is an alias to /src
// Icons
import RadioCheckboxGroup from '@/components/fields/RadioCheckboxGroup.vue';

export default {
  name: 'FieldSet',
  props: [
    'index',
    'field',
  ],
  mounted() {
    this.modelName = this.field.name;
  },
  data() {
    return {
      modelName: '',
    };
  },
  components: {
    RadioCheckboxGroup,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$field-label-dark: $charcoal-dark;

$field-gap: $spacing;

$field-font-size-small: $body-font-size-small;

// Custom styles
.field__title {
  padding: $spacing-quarter 0 0;
  @include nike-heading;
  font-size: $title-font-size;
  line-height: 26px;
}

.field__description {
  margin-bottom: $spacing-quarter;
}
</style>
